import {
  Component,
  Input,
  OnInit,
  EventEmitter,
  Output,
  OnDestroy,
  HostListener
} from "@angular/core";

@Component({
  selector: "app-sortable-column",
  templateUrl: "./sortable-column.component.html",
  styleUrls: ["./sortable-column.component.css"]
})
export class SortableColumnComponent implements OnInit {
  constructor() {}

  @Input() columnName: string; // the current page
  @Input() columnLabelName: string; // the current page
  @Input() sortDirection: string; // how many total items there are in all pages

  @Output() goSort = new EventEmitter<object>();

  onSort() {
    this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
    this.goSort.emit({
      columnName: this.columnName,
      sortDirection: this.sortDirection
    });
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// /var/www/staging.theprintlife.com/src/app/sortable-column/sortable-column.component.ts